import { FC, ReactNode } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/layouts/Layouts.css'
import ExternalLayout from 'components/features/external/ExternalLayout/ExternalLayout'
import { Anchor as AnchorType } from 'interfaces/navigation'
import InternalLayoutContainer from 'components/features/pfm/InternalLayout/InternalLayoutContainer'
import InternalSidebarContainer from 'components/features/pfm/InternalSidebar/InternalSidebarContainer'
import Anchor from 'components/atoms/navigation/Anchor'
import { NotificationTrayWrapper } from 'components/features/pfm/NotificationTray/NotificationTrayWrapper'

type SingleColumnLayoutProps = {
  header?: ReactNode
  limitedWidth?: boolean
  className?: string
}

export const SingleColumnLayout: FC<SingleColumnLayoutProps> = (props) => {
  const { header, children, limitedWidth, className } = props

  if (!header && !children) {
    return null
  }

  const headerChild = header
    ? (
      <header className={ styles.header }>
        { header }
      </header>
    )
    : null

  const componentClassName = cn(styles.singleColumn, {
    [styles.limitedWidth]: limitedWidth,
  }, className)

  return (
    <section className={ componentClassName }>
      { headerChild }
      { children }
    </section>
  )
}

type TwoColumnRowProps = {
  left: ReactNode
  right: ReactNode
  flexLayout?: boolean
  className?: string
}

export const TwoColumnRowLayout: FC<TwoColumnRowProps> = ({ left, right, flexLayout, className }) => {
  const classNames = cn(styles.twoColumnRowLayout, className, {
    [styles.flexLayout]: flexLayout,
  })

  return (
    <div className={ classNames }>
      <div className={ styles.column }>{ left }</div>
      <div className={ styles.column }>{ right }</div>
    </div>
  )
}

export const FeedExternalLayout: FC = ({ children }) => (
  <ExternalLayout type='feed'>
    <div className={ styles.centeredColumnWrapper }>
      <div className={ styles.centeredColumn }>
        { children }
      </div>
    </div>
  </ExternalLayout>
)

type FeedInternalLayoutProps = {
  anchor: AnchorType
}
export const FeedInternalLayout: FC<FeedInternalLayoutProps> = ({ anchor, children }) => (
  <InternalLayoutContainer
    sidebar={ <InternalSidebarContainer backPage='native' /> }
    notifications={ <NotificationTrayWrapper renderLevel='page' isPositionRelative /> }
  >
    <Anchor placement='feedtop'>
      <Anchor placement={ anchor }>
        <SingleColumnLayout>
          { children }
        </SingleColumnLayout>
      </Anchor>
    </Anchor>
  </InternalLayoutContainer>
)

